/**
 * 报告结果刷新服务
 */
export interface ReportResultRefresh {
    /**
     * 刷新报告结果
     */
    refresh(isNeedUpdateTaskStatus?: boolean): Promise<void>;
}

export const ReportResultRefresh = Symbol.for('ReportResultRefresh');
